import React, { useState,useEffect } from 'react';
import axios from 'axios';
import Api from "../Api/Api.json";
import SidebarNav from './SidebarNav';
const VocabExam = () => {
  const [nativeSentence, setNativeSentence] = useState('আমি বর্তমানে ঢাকা, বাংলাদেশে আছি।');
  const [englishSentence, setEnglishSentence] = useState('I am currently in Dhaka, Bangladesh.');
  const [dialogState, setDialogState] = useState('Waiting');
  const [userResponse, setUserResponse] = useState('');
  const [analysisReport, setAnalysisReport] = useState('');
  const [analysisAudioLink, setAnalysisAudioLink] = useState('');
  const [language, setLanguage] = useState('English');
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  useEffect(()=>{ 
    //getUserInfo();
  }
  ,[]);


  const handleGenerateScript = async () => {
    //call api and return script.
    const auth_user = await localStorage.getItem('auth_user');
    const id_token = JSON.parse(auth_user)?.id_token;
    //console.log(id_token);
       
  };

  const analyzeTranslation = async () => {
    const headers = { headers: { "Content-Type": "application/json" } }
    const url = Api.SPOKEN_ENGLISH_USER_API;
    const requestData = {
      task: 'analyzeAnswer',
      actual_translation: englishSentence,
      user_response: userResponse,
    };
    axios.post(url,requestData,headers)
    .then(response=>{
      if (response.data.length > 0){
        setAnalysisReport(response.data[0]);
        setAnalysisAudioLink(response.data[1]);
        setDialogState('Waiting');
      }
    })
    .catch(error=>{
      console.log(error)
    });

    /*
    let utterance = new SpeechSynthesisUtterance(analysisReport);
    utterance.lang = 'bn-IN';
    let voices = speechSynthesis.getVoices();
    if (voices.length > 0) {
        let bengaliVoice = voices.find(voice => voice.lang === 'bn-IN');
        if (bengaliVoice) {
            utterance.voice = bengaliVoice;
        } else {
            console.warn("Bengali voice not found. Using default voice.");
        }
        speechSynthesis.speak(utterance);
    } else {
        speechSynthesis.onvoiceschanged = () => {
            let updatedVoices = speechSynthesis.getVoices();
            let bengaliVoice = updatedVoices.find(voice => voice.lang === 'bn-IN');
            if (bengaliVoice) {
                utterance.voice = bengaliVoice;
            } else {
                console.warn("Bengali voice not found. Using default voice.");
            }
            speechSynthesis.speak(utterance);
        };
    }
    */
}
const handleListening = async () => {
  setDialogState('Listening');
  //Listen for 5 seconds, if no audio, then stop. and transcribe
  if ('webkitSpeechRecognition' in window) {
    const recognition = new window.webkitSpeechRecognition();
    console.log('recognition available');
    
    recognition.continuous = true;
    //recognition.interimResults = true;
    recognition.lang = 'en-US';
    recognition.start();
    setTimeout(() => {
      recognition.stop();
    }, 5000);
    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript;
      setUserResponse(transcript);
      setDialogState('Analyzing');
      analyzeTranslation();
    };
    
  }
};
  const handleSubmitScript = async() => {
    //call api and show message on successful submission.
    const auth_user = await localStorage.getItem('auth_user');
    const id_token = JSON.parse(auth_user)?.id_token;

  };

  const playFeedbackAudio = () => {
    const audio = new Audio(analysisAudioLink);
    audio.play();
  };
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  }

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
      <div
      style={{
        display: "flex", // Use Flexbox for horizontal stacking
        flexDirection: "row", // Stack children horizontally (default)
        justifyContent: "space-between", // Space between children
        alignItems: "center",
        gap: "10px", // Space between children
        padding: "10px", // Padding around the container
        backgroundColor: "#f4f4f4", // Background color
      }}
    > <h2>Coming soon.</h2>
    <button onClick={toggleSidebar}>মেনু</button>
    </div>
      
      {isSidebarVisible && <SidebarNav />}
    </div>
  );

  /*
  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
      <h2>শব্দ পরীক্ষা দিন</h2>
      <div style={{ marginBottom: '20px' }}>
      <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', 
        fontWeight: 'bold',backgroundColor: '#fff', color: '#1e1a8f',padding: '10px', borderRadius: '5px'}}>
          Sentence: {nativeSentence}
        </label>        
        <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        Translation: {englishSentence}
        </label>
        <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        State: {dialogState}
        </label>
        <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        User: {userResponse}
        </label>
        <label htmlFor="description" style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
        Analysis: {analysisReport}
        </label>
      </div>
      <button
        onClick={handleGenerateScript}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: '5px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        আবার শুনুন
      </button>

      <button
        onClick={handleListening}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: '5px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        বলুন
      </button>
      <button
        onClick={playFeedbackAudio}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: '5px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        Play Feedback
      </button>
      <SidebarNav />
    </div>
  );
  */
};

export default VocabExam;
